module.exports = __webpack_public_path__ + "media/icons/line-d9ae3109.png";